import React from 'react';
import ContactForm from "./ContactForm";
import { FiMail , FiMapPin } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const ContactOne = () => {
    const { t } = useTranslation('enterprise');
    return (
        <>
            <div className="row row--15">
                <div className="col-lg-12">
                    <div className="rn-contact-address mt_dec--30">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiMail />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">{t('contactPage.email')}</h4>
                                        <p><a href="mailto:support@n01zet.com">support@n01zet.com</a></p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiMapPin />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">{t('contactPage.location')}</h4>
                                        <p>33 rue La Fayette 75009 Paris France</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt--40 row--15">
                <div className="col-lg-7">
                    <ContactForm formStyle="contact-form-1" />
                </div>
            </div>
        </>
    )
}
export default ContactOne;